module.exports = __webpack_public_path__ + "img/middle1.a3140253.png";